import React, { useEffect } from 'react';
import Icon from './Icon';
import styles from './ConfirmDialog.module.css';

// Generic in-page confirm dialog. Replaces window.confirm so the confirmation
// lives in the app's design language (navy tokens, rounded corners, shadow)
// instead of the raw OS prompt. Supports 1–3 buttons via the buttons array;
// each button sets its variant (primary / danger / subtle) and onClick.
// The caller owns the open/close state and is responsible for unmounting.
export default function ConfirmDialog({
  title,
  message,
  buttons = [],
  onCancel,
}) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === 'Escape') onCancel?.();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return (
    <div className={styles.backdrop} onClick={onCancel}>
      <div className={styles.dialog} onClick={e => e.stopPropagation()}>
        <div className={styles.header}>
          <span className={styles.title}>{title}</span>
          <button className={styles.close} onClick={onCancel} title="Close">
            <Icon name="x" size={13} />
          </button>
        </div>
        {message != null && (
          <div className={styles.body}>
            {typeof message === 'string'
              ? message.split('\n').map((line, i) => <p key={i}>{line}</p>)
              : message}
          </div>
        )}
        <div className={styles.footer}>
          {buttons.map((b, i) => (
            <button
              key={i}
              className={`${styles.btn} ${styles[`btn_${b.variant || 'subtle'}`]}`}
              onClick={b.onClick}
              disabled={b.disabled}
              autoFocus={b.autoFocus}
            >
              {b.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
